import { createContext } from 'react'

import type { LoginCredentials, SessionUser } from '@/services/auth'

export type AuthStatus = 'initializing' | 'authenticated' | 'unauthenticated' | 'disabled'

export interface AuthContextValue {
  status: AuthStatus
  user: SessionUser | undefined
  /**
   * True when the user may access protected routes. Also true while auth is
   * disabled, so the app behaves exactly as before the auth layer landed.
   */
  isAuthenticated: boolean
  login: (credentials: LoginCredentials) => Promise<void>
  logout: () => Promise<void>
  getAccessToken: () => Promise<string | undefined>
  hasRole: (...roles: string[]) => boolean
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined)
